export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = true;
    public static readonly VERBOSE = false;
    public static readonly SKIP_INTRO = true;
    
    public static readonly GAME_WIDTH = 1200;
    public static readonly GAME_HEIGHT = 900;

    public static readonly GENDER_MALE = "male";
    public static readonly GENDER_FEMALE = "fem";

    public static readonly DIFFICULTY_CASUAL = "difficulty casual";
    public static readonly DIFFICULTY_REGULAR = "difficulty regular";
    public static readonly DIFFICULTY_EXPERT = "difficulty expert";

    public static readonly TUTORIAL_1_1 = "tutorial 1 1";
    public static readonly TUTORIAL_1_2 = "tutorial 1 2";
    public static readonly TUTORIAL_1_3 = "tutorial 1 3";
    public static readonly TUTORIAL_1_4 = "tutorial 1 4";
    public static readonly TUTORIAL_1_5 = "tutorial 1 5";
    public static readonly TUTORIAL_1_6 = "tutorial 1 6";
    public static readonly TUTORIAL_1_7 = "tutorial 1 7";
    public static readonly TUTORIAL_2 = "tutorial 2";
    public static readonly TUTORIAL_3 = "tutorial 3";
    public static readonly TUTORIAL_4_1 = "tutorial 4 1";
    public static readonly TUTORIAL_4_2 = "tutorial 4 2";
    public static readonly TUTORIAL_5 = "tutorial 5";

    public static readonly END_WIN = "win";
    public static readonly END_LOSE = "lose";

    public static ENGLISH = "en";
    public static GERMAN = "de";

    public static readonly SAVED_GAME_DATA_KEY = "stop-the-bus-data";
}
